import React from 'react';
import BaseSidePanel from 'components/sidePanel/baseSidePanel';
import { ITabItem } from 'components/tab';
import ExperimentTools from './ExperimentTools';
const tabItems_: ITabItem[] = [
  {
    content: <ExperimentTools />,
  },
];
const ImageTools = () => {
  return <BaseSidePanel id='commandpanel-exptools-image'  tabItems={tabItems_} headerTitle={'Tools'} />;
};
export default ImageTools;
